// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Typography,
//   Card,
//   CardContent,
//   Collapse,
//   IconButton,
//   Button,
//   CircularProgress, 
// } from '@mui/material';

// import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
// import CreditCardIcon from '@mui/icons-material/CreditCard';

// import { api } from './api';
// import { api as api2 } from '../suministros/api';

// const MisPagos = ({ suministroId, cliCod }) => {
//   const [pagos, setPagos] = useState([]);
//   const [expandedId, setExpandedId] = useState(null);

//   // PAGINATION
//   const [page, setPage] = useState(1);
//   const limit = 20;

  
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchPagos = async () => {
//       if (!suministroId || !cliCod) return;
//       setLoading(true); 

//       try {
//         const res = await api.pagos.getPagosBySuministro(suministroId, cliCod, page, limit);
//         setPagos(res.data);
//       } catch (err) {
//         console.error("Error al cargar pagos:", err);
//       } finally {
//         setLoading(false); 
//       }
//     };

//     fetchPagos();
//   }, [suministroId, cliCod, page]);

//   const handleToggle = (id) => {
//     setExpandedId(expandedId === id ? null : id);
//   };

//   return (
//     <Box mt={3}>

//       {loading && (
//         <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
//           <CircularProgress size={40} />
//           <Typography mt={2} color="text.secondary">
//             Cargando pagos…
//           </Typography>
//         </Box>
//       )}

//       {!loading && pagos.length === 0 && (
//         <Typography>No tenés pagos registrados.</Typography>
//       )}

//       {!loading && pagos.length > 0 && (
//         pagos.map((pago) => (
//           <Card
//             key={pago.resuNro}
//             sx={{
//               mb: 2,
//               borderRadius: 3,
//               boxShadow: 4,
//               borderLeft: '4px solid #64AE37',
//               '&:hover': { boxShadow: 6, transform: 'translateY(-2px)', transition: '0.3s' },
//             }}
//           >
//             <CardContent
//               sx={{
//                 display: 'flex',
//                 flexDirection: { xs: 'column', sm: 'row' },
//                 alignItems: { xs: 'flex-start', sm: 'center' },
//                 justifyContent: 'space-between',
//                 gap: 2,
//               }}
//             >
//               <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                 <CreditCardIcon sx={{ fontSize: 36, mr: 2, color: 'primary.main' }} />

//                 <Box>
//                   <Typography variant="subtitle1" fontWeight="bold">
//                     Nro de comprobante: {pago.ResuCodigo}
//                   </Typography>

//                   <Typography variant="subtitle2" color="text.secondary">
//                     <strong>Fecha:</strong> {new Date(pago.resuFec).toLocaleDateString()}
//                   </Typography>

//                   <Typography variant="subtitle1" color="text.secondary">
//                     <strong>Importe:</strong> ${pago.resuImp}
//                   </Typography>
//                 </Box>
//               </Box>

//               <Box display="flex" gap={1}>
//                 <IconButton onClick={() => handleToggle(pago.resuNro)}>
//                   <ExpandMoreIcon />
//                 </IconButton>
//               </Box>
//             </CardContent>

//             <Collapse in={expandedId === pago.resuNro} timeout="auto" unmountOnExit>
//               <Box sx={{ p: 2, bgcolor: 'grey.100' }}>
//                 <Typography variant="subtitle2" fontWeight="bold" mb={2}>
//                   Facturas abonadas
//                 </Typography>

//                 {pago.facturas?.map((f) => (
//                   <Box key={f.ResuCptCnc} display="flex" alignItems="center" mb={2}>
//                     <ReceiptLongIcon sx={{ mr: 2, color: 'primary.main' }} />
//                     <Box>
//                       <Typography variant="body1">
//                         <strong>{f.Servicio}</strong>
//                       </Typography>
//                       <Typography variant="body2">{f.FactCodigo}</Typography>

//                       <Typography variant="body2">
//                         <strong>Monto:</strong> ${f.ResuImpCnc} &nbsp; | &nbsp;
//                         <strong>Venc:</strong> {new Date(f.ResuFecCnc).toLocaleDateString()}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             </Collapse>
//           </Card>
//         ))
//       )}
//     </Box>
//   );
// };

// export default MisPagos;
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  CircularProgress,
  Button
} from '@mui/material';

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import { api } from './api';

const MisPagos = ({ suministroId, cliCod }) => {
  const [facturas, setFacturas] = useState([]);
  const [page, setPage] = useState(1);
  const limit = 20;

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPagos = async () => {
      if (!suministroId || !cliCod) return;
      setLoading(true);

      try {
        const res = await api.pagos.getPagosBySuministro(
          suministroId,
          cliCod,
          page,
          limit
        );

        // 🔥 TOMAR SOLO FACTURAS (no pagos) y SOLO las que no son tipo 1
        const facturasFiltradas = res.data
          .flatMap((p) =>
            p.facturas.map((f) => ({
              ...f,
              FechaPago: p.resuFec, // ⬅ FECHA DE PAGO VIENE DEL PAGO
              pdf: p.pdf // ⬅ PDF del pago o de factura según tu backend
            }))
          )
          .filter((f) => f.ResuTpoCnc !== 1);

        setFacturas(facturasFiltradas);
      } catch (err) {
        console.error('Error al cargar facturas:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPagos();
  }, [suministroId, cliCod, page]);

  const handleDownloadPDF = (pdfBase64) => {
    const link = document.createElement('a');
    link.href = `data:application/pdf;base64,${pdfBase64}`;
    link.download = 'factura.pdf';
    link.click();
  };

  return (
    <Box mt={3}>
      {loading && (
        <Box display="flex" flexDirection="column" alignItems="center" mt={4}>
          <CircularProgress size={40} />
          <Typography mt={2} color="text.secondary">
            Cargando facturas…
          </Typography>
        </Box>
      )}

      {!loading && facturas.length === 0 && (
        <Typography>No tenés facturas registradas.</Typography>
      )}

      {!loading &&
        facturas.length > 0 &&
        facturas.map((f) => (
          <Card
            key={f.ResuCptCnc}
            sx={{
              mb: 2,
              borderRadius: 3,
              boxShadow: 4,
              borderLeft: '4px solid #64AE37'
            }}
          >
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <ReceiptLongIcon
                  sx={{ fontSize: 36, mr: 2, color: 'primary.main' }}
                />

                <Box>
                  {/* Código de factura */}
                  <Typography variant="subtitle1" fontWeight="bold">
                    {f.FactCodigo}
                  </Typography>

                  {/* Servicio */}
                  <Typography variant="body2" color="text.secondary">
                    <strong>Servicio:</strong> {f.Servicio}
                  </Typography>
                                    {/* Fecha de pago */}
                  <Typography variant="body2" color="text.secondary">
                    <strong>Fecha pago:</strong>{' '}
                    {f.FechaPago
                      ? new Date(f.FechaPago).toLocaleDateString()
                      : '—'}
                  </Typography>

              {/* Importe destacado */}
              <Box
                sx={{
                  mt: 1,
                  display: 'inline-block',
                  px: 1.5,
                  py: 0.5,
                  border: '2px solid #64AE37',
                  borderRadius: 2,
                  bgcolor: 'rgba(100, 174, 55, 0.1)', // verde muy suave
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#2E7D32' }}>
                  Importe: ${f.ResuImpCnc}
                </Typography>
              </Box>

                </Box>
              </Box>

              {/* Botón de descarga PDF */}
              {f.pdf && (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  // startIcon={<PictureAsPdfIcon />}
                  onClick={() => handleDownloadPDF(f.pdf)}
                  sx={{ height: 36 }}
                >
                  Descargar
                </Button>
              )}
            </CardContent>
          </Card>
        ))}
    </Box>
  );
};

export default MisPagos;
